import { BaseApiResponseModel } from "api/baseApiResponseModel/BaseApiResponseModel";
import { dummySidebar } from "utils/dummyData/DummySidebar";
import {
  MenuConfigModel,
  SidebarMenuConfigModel,
} from "./model/SidebarMenuConfigModel";

export interface IConfigRepository {
  getSidebarMenu(
    role: boolean
  ): Promise<BaseApiResponseModel<SidebarMenuConfigModel>>;
}

export interface IMenuService {
  name: string;
  path: string;
  componentName: string;
  icon: string;
  subMenu?: IMenuService[] | [];
  enable?: boolean;
}

export class SidebarMenuConfigRepository implements IConfigRepository {
  async getSidebarMenu(
    role: boolean,
    language?: string
  ): Promise<BaseApiResponseModel<SidebarMenuConfigModel>> {
    let menuConfig: MenuConfigModel[] = [];
    let rawMenu: IMenuService[] = [];

    switch (language) {
      case "vi":
        rawMenu = dummySidebar?.vi as Array<IMenuService>;
        break;
      case "en":
        rawMenu = dummySidebar?.eng as Array<IMenuService>;
        break;
      default:
        rawMenu = dummySidebar?.vi as Array<IMenuService>;
    }

    if (!role) {
      rawMenu = this.removeStoreManagement(rawMenu);
    }

    menuConfig = this.mapMenuItems(rawMenu);

    return Promise.resolve(
      new BaseApiResponseModel<SidebarMenuConfigModel>(
        undefined,
        new SidebarMenuConfigModel(menuConfig),
        undefined,
        undefined
      )
    );
  }

  private removeStoreManagement = (
    items: IMenuService[] = []
  ): IMenuService[] =>
    items?.map((ele) => ({
      ...ele,
      subMenu: ele.subMenu?.filter(
        (child) => child?.componentName !== "StoreManagementFeature"
      ),
    }));

  private mapMenuItems(items: IMenuService[] = []): MenuConfigModel[] {
    return items
      .filter((item) => item.enable !== false)
      .map(
        (item) =>
          new MenuConfigModel(
            item.name,
            item.path,
            item.componentName,
            item.icon,
            this.mapMenuItems(item.subMenu)
          )
      );
  }
}

export default new SidebarMenuConfigRepository();
